export function cleanMask(value) {
  value = value.replace(/\D/g, '')
  return value
}

export function cleanMaskDocument(value) {
  value = value.replace(/[.\-\s]/g, '')
  return value
}
